var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "select-template-container" },
    [
      _c(
        "b-row",
        [
          _c("b-col", { attrs: { cols: "12" } }, [
            _c("p", [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$t("e-sign-package.messages.selectPreExistingTemplate")
                  ) +
                  "\n      "
              ),
            ]),
          ]),
          _vm._v(" "),
          _vm.amountOfSignerRoles
            ? _c("b-col", { attrs: { cols: "12" } }, [
                !_vm.matchableTemplateSelected
                  ? _c("h6", { staticClass: "text-warning" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.$t(
                              "e-sign-package.messages.warningSelectedTemplate",
                              {
                                amountOfSignerRoles: _vm.amountOfSignerRoles,
                                type: _vm.$tc(
                                  "global.words.type",
                                  _vm.amountOfSignerRoles
                                ),
                                amountOfApplicationSigners:
                                  _vm.amountOfApplicationSigners,
                                signer: _vm.$tc(
                                  "e-sign-package.signer",
                                  _vm.amountOfApplicationSigners
                                ),
                              }
                            )
                          ) +
                          "\n      "
                      ),
                    ])
                  : _vm._e(),
              ])
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-3 align-items-center" },
        [
          _c("b-col", { attrs: { cols: "8" } }, [
            _c(
              "div",
              {
                staticClass: "form-group-material select-esign-template",
                attrs: { id: "select-esign-template" },
              },
              [
                _c("select2", {
                  ref: "select",
                  attrs: {
                    id: "select-esign-template-select",
                    data: _vm.completeTemplates,
                    value: _vm.currentTemplateData.eSignTemplateId,
                    name: "eSignTemplates",
                    options: _vm.options,
                    "format-data": _vm.formatData,
                  },
                  on: { change: _vm.handleSelectTemplate },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "bar" }),
                _vm._v(" "),
                _c(
                  "label",
                  { staticClass: "title text-light-gray mb-2 mb-lg-0" },
                  [_vm._v(_vm._s(_vm.$t("documents.selectATemplate")))]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "b-col",
            {
              staticClass:
                "pb-2 d-flex flex-row justify-content-end align-items-center",
              attrs: { cols: "auto" },
            },
            [
              _c(
                "button",
                {
                  staticClass: "btn btn-danger btn-sm mr-2",
                  attrs: { type: "button" },
                  on: { click: _vm.clearTemplate },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("global.words.clear")) +
                      "\n      "
                  ),
                ]
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.currentTemplateData.eSignTemplateId
        ? [
            _c(
              "b-row",
              { staticClass: "align-items-start mt-2" },
              [
                _c("b-col", { attrs: { cols: "12", lg: "4" } }, [
                  _c("h6", { staticClass: "bold mb-1 font-sm" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("global.words.name")) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "m-0 text-grey" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.currentTemplateData.name) +
                        "\n        "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("b-col", { attrs: { cols: "12", lg: "8" } }, [
                  _c("h6", { staticClass: "bold mb-1 font-sm" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("global.words.description")) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "m-0 text-grey" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.currentTemplateData.description) +
                        "\n        "
                    ),
                  ]),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              { staticClass: "align-items-start my-4" },
              [
                _c(
                  "b-col",
                  { attrs: { cols: "12", lg: "4" } },
                  [
                    _c("h6", { staticClass: "bold mb-1 font-sm" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("e-sign-package.emailSubject")) +
                          "\n          "
                      ),
                      !_vm.editing.title
                        ? _c(
                            "span",
                            [
                              _c("icon", {
                                staticClass: "text-primary clickable ml-2",
                                attrs: { name: "pencil" },
                                on: {
                                  click: function ($event) {
                                    return _vm.editTemplateData("title", true)
                                  },
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _vm.editing.title
                      ? _c(
                          "material-input",
                          { attrs: { value: _vm.currentTemplateData.title } },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.currentTemplateData.title,
                                  expression: "currentTemplateData.title",
                                },
                              ],
                              staticClass:
                                "material-input form-control form form-control-filled",
                              attrs: { type: "text" },
                              domProps: {
                                value: _vm.currentTemplateData.title,
                              },
                              on: {
                                blur: function ($event) {
                                  return _vm.editTemplateData("title", false)
                                },
                                keypress: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.editTemplateData("title", false)
                                },
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.currentTemplateData,
                                    "title",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]
                        )
                      : _c("p", { staticClass: "m-0 text-grey" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.currentTemplateData.title) +
                              "\n        "
                          ),
                        ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { cols: "12", lg: "4" } },
                  [
                    _c("h6", { staticClass: "bold mb-1 font-sm" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("e-sign-package.emailMessage")) +
                          "\n          "
                      ),
                      !_vm.editing.message
                        ? _c(
                            "span",
                            [
                              _c("icon", {
                                staticClass: "text-primary clickable ml-2",
                                attrs: { name: "pencil" },
                                on: {
                                  click: function ($event) {
                                    return _vm.editTemplateData("message", true)
                                  },
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _vm.editing.message
                      ? _c(
                          "material-input",
                          { attrs: { value: _vm.currentTemplateData.message } },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.currentTemplateData.message,
                                  expression: "currentTemplateData.message",
                                },
                              ],
                              staticClass:
                                "material-input form-control form form-control-filled",
                              attrs: { type: "text" },
                              domProps: {
                                value: _vm.currentTemplateData.message,
                              },
                              on: {
                                blur: function ($event) {
                                  return _vm.editTemplateData("message", false)
                                },
                                keypress: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.editTemplateData("message", false)
                                },
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.currentTemplateData,
                                    "message",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]
                        )
                      : _c("p", { staticClass: "m-0 text-grey" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.emailMessage) +
                              "\n        "
                          ),
                        ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              { staticClass: "align-items-start" },
              [
                _c("b-col", { attrs: { cols: "12", lg: "4" } }, [
                  _c("h6", { staticClass: "bold mb-1 font-sm" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$tc("e-sign-package.signerType", 2)) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "signer-types-container overflow-auto",
                      staticStyle: { "max-height": "10rem" },
                    },
                    [
                      _c(
                        "ul",
                        { staticClass: "list-style-disc" },
                        _vm._l(
                          _vm.currentTemplateData.signerRoles,
                          function (role, index) {
                            return _c("li", { key: role.name + "-" + index }, [
                              _c("p", { staticClass: "m-0 text-grey" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(role.name) +
                                    "\n              "
                                ),
                              ]),
                            ])
                          }
                        ),
                        0
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("b-col", { attrs: { cols: "12", lg: "8" } }, [
                  _c("h6", { staticClass: "bold mb-1 font-sm" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm._f("capitalize")(_vm.$tc("global.words.file", 2))
                        ) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "files-container overflow-auto",
                      staticStyle: { "max-height": "10rem" },
                    },
                    [
                      _c(
                        "ul",
                        { staticClass: "list-style-disc" },
                        _vm._l(_vm.currentTemplateData.files, function (file) {
                          return _c("li", { key: file.documentId }, [
                            _c("p", { staticClass: "m-0 text-grey" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm._f("truncateFileName")(
                                      file.fileName,
                                      _vm.fileNameMaxLength
                                    )
                                  ) +
                                  "\n              "
                              ),
                            ]),
                          ])
                        }),
                        0
                      ),
                    ]
                  ),
                ]),
              ],
              1
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }